import {
  AbsoluteCenter,
  Box,
  chakra,
  Checkbox,
  Flex,
  Icon,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { isValidMotionProp, motion } from "framer-motion";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const CommonModal = ({
  onConfirm,
  onCancel,
  setChecked,
  checked,
  children,
  title,
  bgNone,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  // useEffect(() => {
  //   setKey((prev) => prev + 1); // 每次組件掛載時更新 key
  //   const timer = setTimeout(() => {
  //     setShowOverlay(false);
  //   }, 400);
  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg={bgNone ? "" : "rgba(0, 0, 0, 0.8)"}
      zIndex="9999"
      w="100%"
      h="100%"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="420px"
        minH="350px"
        bgImage={`url('${COMMON_WEB_PATH}/theOne/modal/hintBG.webp')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position={"relative"}
        p={6}
        pt={"80px"}
      >
        <Box
          display="flex"
          alignItems={"center"}
          justifyContent={"center"}
          position="absolute"
          top="16px"
          right="10px"
          w="120px"
        >
          <Text
            fontWeight={"400"}
            fontSize="24px"
            textShadow={"0 0 1.5px white"}
          >
            {title || i18n("提醒")}
          </Text>
        </Box>
        {/* 隱形XX */}
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems={"center"}
          // position="relative"
          gap="20px"
          zIndex={2}
          w="100%"
          minH="250px"
          bgImage={`url('${COMMON_WEB_PATH}/theOne/modal/hint_bg_inner.webp')`}
          bgSize="100%100%"
          bgRepeat="no-repeat"
          bgPos="center"
          py="20px"
        >
          {children}
        </Flex>
      </ChakraBox>
    </Flex>
  );
};

export default CommonModal;
